import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import moment from 'moment'
import axios from 'axios'

import * as types from './store/mutation-types';
import { API_URL } from '@/helpers/constants'
import { formatNumber } from '@/helpers/functions'
import eventBus from './helpers/event-bus'
import './registerServiceWorker'
import initNotifications from '@/notifications/notifications'
import i18n from './i18n/i18n'
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';

Vue.config.productionTip = false
Vue.prototype.$eventBus = eventBus;
Vue.filter('formatNumber', formatNumber)
window.moment = moment;

window.axios = axios.create({
	baseURL: API_URL
});

Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);

moment.updateLocale('en', {
	week: {
		dow: 6 // السبت بداية الأسبوع
	}
});
// moment.updateLocale() re-activates the locale it touches ('en'), silently undoing the
// language-appropriate locale i18n.js already set on boot - restore it here.
moment.locale(i18n.locale === 'ar' ? 'ar-lev' : 'en');

let controller = {};
if ('AbortController' in window) {
	controller = new AbortController();
	router.beforeEach((to, from, next) => {
		if (from.name) { controller.abort(); controller = new AbortController(); }
		next();
	});
}

window.axios.interceptors.request.use(configs => {
	if (!configs.preventRouteAbort) {
		// عدم إضافة signal للطلبات التي لا يجب أن تُلغى عند تغيير الصفحة
		configs.signal = controller.signal;
	}
	return configs
});

window.axios.interceptors.response.use(
	response => response,
	error => {
		if (error.code === 'ERR_CANCELED') return Promise.reject(error);
		// خطأ شبكة (لا يوجد اتصال بالإنترنت): لا رد فعلي من الخادم، فلا تُظهر رسالة الخطأ العامة
		if (!error.response) return Promise.reject(error);
		if (!error.config.preventHandling) {
			if (error.response?.status === 401 && router.currentRoute.name !== 'login') {
				store.dispatch('auth/logout');
				router.replace({ name: 'login' })
			}
			if (router.currentRoute.name !== 'login') {
				// تحقق من أن الـ response عبارة عن JSON وليس binary
				let errorMessage = 'Unknown error';
				try {
					if (error.response?.data && typeof error.response.data === 'object' && !(error.response.data instanceof Blob)) {
						errorMessage = error.response.data.message || i18n.t('one-of-the-fields-is-missing-or-entered-incorrectly');
					} else {
						errorMessage = i18n.t('one-of-the-fields-is-missing-or-entered-incorrectly');
					}
				} catch (e) {
					errorMessage = i18n.t('one-of-the-fields-is-missing-or-entered-incorrectly');
				}
				eventBus.$emit('show-snackbar', errorMessage, 'error');
			}
		}
		return Promise.reject(error)
	}
)

if ('auth' in localStorage) {
	try {
		const auth = JSON.parse(localStorage.getItem('auth'));
		const authHeader = `Bearer ${auth.token}`;

		window.axios.defaults.headers.common.Authorization = authHeader;
		// platformUsed 2: IOS
		window.axios.defaults.headers.common.platformUsed = 2;
		// commit LOGIN immediately so the router guard sees authenticated=true before getSelf resolves
		store.commit(`auth/${types.LOGIN}`, auth);
		store.dispatch('auth/getSelf')
			.catch((error) => {
				// خطأ شبكة (غير متصل بالإنترنت): يبقى المستخدم مسجلاً بالبيانات المخزّنة مسبقاً
				if (!error.response) return;
				store.dispatch('auth/logout');
				localStorage.removeItem('auth');
				router.push({ name: 'login' });
			});
	} catch (e) {
		localStorage.removeItem('auth');
	}
} else {
	router.push({ name: 'login' });
}

// تهيئة إشعارات FCM (Firebase Cloud Messaging)
initNotifications({ store, router })

new Vue({
	router,
	store,
	vuetify,
	i18n,
	render: h => h(App)
}).$mount('#app')
